import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import { useLocalizeMessage, Table, Badge } from 'libs.nucleus';
export const CloneViewSelect = ({ dataViews, isLoading, selectedViewId, onViewSelect }) => {
    const translate = useLocalizeMessage();
    // Filter to only show datasets that can be cloned (non-archived)
    // Archived datasets have active === false
    const cloneableViews = useMemo(() => dataViews.filter((view) => view.active !== false), [dataViews]);
    const columns = useMemo(() => [
        {
            header: translate('Name'),
            accessorKey: 'name',
            cell: ({ row }) => _jsx("span", { className: 'text-primary-500 font-medium', children: row.original.name }),
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            accessorFn: (row) => row.metadata?.description || '',
        },
        {
            header: translate('Version'),
            accessorKey: 'version',
            cell: ({ row }) => _jsx(Badge, { label: `V${row.original.version}` }),
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            cell: ({ row }) => {
                const { status } = row.original;
                const statusLabels = {
                    DRAFT: translate('In Progress'),
                    IN_REVIEW: translate('In Review'),
                    PUBLISHED: translate('Ready for Use'),
                };
                return _jsx(Badge, { label: statusLabels[status] || status });
            },
        },
    ], [translate]);
    // Reset selection if selected view is no longer in the list
    useEffect(() => {
        if (selectedViewId && !cloneableViews.find((v) => v.id === selectedViewId)) {
            onViewSelect(null);
        }
    }, [cloneableViews, selectedViewId, onViewSelect]);
    const emptyStateMessage = useMemo(() => {
        if (dataViews.length === 0) {
            return translate('No dataset available for cloning. Go back and create one manually to get started.');
        }
        return translate('No datasets found matching your search.');
    }, [dataViews.length, translate]);
    return (_jsx("div", { className: 'flex flex-col size-full p-4', children: _jsx(Table, { columns: columns, data: cloneableViews, isLoading: isLoading, hasPagination: true, initialPageSize: 10, paginationNavigationScreenReaderLabel: translate('Pagination navigation'), isSelectable: true, isSingleSelect: true, getRowId: (row) => row.id, selectedIds: selectedViewId ? [selectedViewId] : undefined, onRowSelectionChange: (ids) => onViewSelect(ids[0] || null), useInternalSearch: true, labelNoResults: emptyStateMessage }) }));
};
